module.exports = __webpack_public_path__ + "img/it-support-pictur.f3a26aef.webp";